import React, { useState, useRef } from 'react';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Form } from '@unform/web';
import PropTypes from 'prop-types';
// importando os services
import api from '~/services/api';
import history from '~/services/history';

// Componentes
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';
import Card from '~/components/Card';

import { Container } from './styles';

export default function Resposta({ match }) {
  const inputRef = useRef(null);
  const [carregar, setCarregar] = useState(false);

  async function handlerSubmit(data) {
    try {
      setCarregar(true);
      const { idProduct, idQuizzes } = match.params;
      inputRef.current.setErrors({});
      const schema = Yup.object().shape({
        resposta: Yup.string().required('Preencha o campo resposta'),
      });
      await schema.validate(data, {
        abortEarly: false,
      });

      await api.post(`pergunta/${idQuizzes}/alternativas`, {
        resposta: data.resposta,
      });

      toast.success('Resposta cadastrado com sucesso');
      history.push(`/questionario-edit/${idProduct}/quizzes/${idQuizzes}`);
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao cadastrar resposta verifique os dados');
      }
    } finally {
      setCarregar(false);
    }
  }

  return (
    <Container>
      <h4>Cadastro de Respostas</h4>
      <Card>
        <Form ref={inputRef} onSubmit={handlerSubmit} autoComplete="off">
          <Input icon="MdPerson" name="resposta" label="Resposta" type="text" />
          <Button tamanho="40px" load={carregar}>
            Cadastrar
          </Button>
        </Form>
      </Card>
    </Container>
  );
}

Resposta.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      idProduct: PropTypes.string,
      idQuizzes: PropTypes.string,
    }),
  }).isRequired,
};
